import { render, staticRenderFns } from "./loadingScreen.vue?vue&type=template&id=de8bc816&scoped=true&"
var script = {}
import style0 from "./loadingScreen.vue?vue&type=style&index=0&id=de8bc816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8bc816",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de8bc816')) {
      api.createRecord('de8bc816', component.options)
    } else {
      api.reload('de8bc816', component.options)
    }
    module.hot.accept("./loadingScreen.vue?vue&type=template&id=de8bc816&scoped=true&", function () {
      api.rerender('de8bc816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/loadingScreen.vue"
export default component.exports